export const heroComics = [
  {
    id: 'comic-1',
    title: '剑与魔法',
    titleKo: '검과 마법',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20adventure%20cover%20art%20featuring%20a%20warrior%20with%20sword%20and%20magical%20energy%2C%20dramatic%20lighting%2C%20epic%20composition%2C%20detailed%20illustration%2C%20warm%20golden%20and%20dark%20tones%2C%20professional%20comic%20cover%20design&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    rating: 9.6,
    reads: '1.2亿',
    status: 'ongoing',
    genres: ['奇幻', '动作', '冒险'],
  },
  {
    id: 'comic-2',
    title: '甜蜜陷阱',
    titleKo: '달콤한 함정',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20featuring%20a%20beautiful%20couple%20in%20soft%20embrace%2C%20pastel%20pink%20and%20warm%20tones%2C%20romantic%20atmosphere%2C%20delicate%20linework%2C%20professional%20webtoon%20cover%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    rating: 9.3,
    reads: '8900万',
    status: 'ongoing',
    genres: ['恋爱', '日常'],
  },
  {
    id: 'comic-3',
    title: '暗夜追踪者',
    titleKo: '나이트 트래커',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20art%20featuring%20a%20mysterious%20detective%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20urban%20night%20setting%2C%20intense%20mood%2C%20professional%20comic%20cover%20with%20strong%20contrast&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    rating: 9.5,
    reads: '6700万',
    status: 'ongoing',
    genres: ['悬疑', '动作'],
  },
];

export const hotWorks = [
  {
    id: 'comic-4',
    title: '重生之帝',
    titleKo: '환생의 제왕',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20reincarnation%20manhwa%20cover%20art%2C%20ancient%20oriental%20palace%20background%2C%20powerful%20emperor%20figure%2C%20golden%20and%20crimson%20tones%2C%20grand%20atmosphere%2C%20detailed%20costume%20design%2C%20professional%20webtoon%20cover&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    rating: 9.7,
    reads: '2.5亿',
    status: 'ongoing',
    genres: ['奇幻', '动作'],
    updateDay: '每周一、四更新',
    description: '一代帝王死后重生，凭借前世记忆改写命运，再登巅峰！',
  },
  {
    id: 'comic-5',
    title: '办公室罗曼史',
    titleKo: '오피스 로맨스',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20office%20romance%20manhwa%20cover%20art%2C%20stylish%20business%20couple%20in%20modern%20office%2C%20soft%20warm%20lighting%2C%20elegant%20fashion%2C%20romantic%20atmosphere%2C%20clean%20professional%20webtoon%20style%2C%20soft%20color%20palette&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    rating: 9.2,
    reads: '1.1亿',
    status: 'ongoing',
    genres: ['恋爱', '日常'],
    updateDay: '每周二、五更新',
    description: '高冷女上司和暖男下属之间甜蜜又爆笑的办公室恋情。',
  },
  {
    id: 'comic-6',
    title: '末日生存指南',
    titleKo: '종말 생존 가이드',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20post-apocalyptic%20survival%20manhwa%20cover%20art%2C%20destroyed%20cityscape%20background%2C%20survivor%20with%20weapon%2C%20dramatic%20orange%20sky%2C%20intense%20atmosphere%2C%20detailed%20ruins%2C%20professional%20webtoon%20cover%20design&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    rating: 9.4,
    reads: '9800万',
    status: 'completed',
    genres: ['动作', '悬疑'],
    updateDay: '已完结',
    description: '末日降临，普通人如何运用智慧与勇气在废墟中生存下去？',
  },
  {
    id: 'comic-7',
    title: '魔法学院',
    titleKo: '마법 아카데미',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20magic%20academy%20manhwa%20cover%20art%2C%20students%20in%20magical%20school%20uniforms%2C%20floating%20spells%20and%20books%2C%20gothic%20architecture%20background%2C%20mystical%20blue%20and%20gold%20tones%2C%20professional%20webtoon%20cover&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    rating: 9.1,
    reads: '7500万',
    status: 'ongoing',
    genres: ['奇幻', '日常'],
    updateDay: '每周三、六更新',
    description: '平凡少年意外进入魔法学院，展开一段奇幻又热血的校园生活。',
  },
  {
    id: 'comic-8',
    title: '江湖风云录',
    titleKo: '강호풍운록',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20murim%20manhwa%20cover%20art%2C%20warrior%20in%20traditional%20hanbok%20with%20sword%2C%20mountain%20landscape%20background%2C%20ink%20wash%20painting%20style%2C%20dramatic%20composition%2C%20elegant%20traditional%20aesthetic&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    rating: 9.5,
    reads: '1.6亿',
    status: 'ongoing',
    genres: ['动作', '剧情'],
    updateDay: '每周一、四更新',
    description: '江湖恩怨，儿女情长，一场跨越三代人的武林传奇。',
  },
  {
    id: 'comic-9',
    title: '猫咪咖啡厅',
    titleKo: '고양이 카페',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20cover%20art%2C%20cozy%20cat%20cafe%20interior%2C%20cute%20cats%20and%20warm%20atmosphere%2C%20soft%20pastel%20colors%2C%20healing%20vibe%2C%20gentle%20lighting%2C%20professional%20webtoon%20cover%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    rating: 9.0,
    reads: '5200万',
    status: 'completed',
    genres: ['日常', '搞笑'],
    updateDay: '已完结',
    description: '在猫咪咖啡厅工作的日常，温暖治愈的短篇故事合集。',
  },
];

export const reviews = [
  {
    id: 'review-1',
    text: '画风真的太绝了！每一帧都像壁纸一样精美，剧情也环环相扣，追更根本停不下来。这个平台更新速度也很快，强烈推荐！',
    author: '星辰大海',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20young%20woman%20with%20soft%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20professional%20headshot&width=120&height=120&seq=avatar-reviewer-01&orientation=squarish',
    role: 'VIP 读者',
    rating: 5,
  },
  {
    id: 'review-2',
    text: '一直在找能稳定看韩漫的地方，终于找到了！资源很全，分类清晰，阅读体验也很流畅，已经推荐给身边所有喜欢漫画的朋友了。',
    author: '二次元少年',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20young%20man%20with%20glasses%2C%20friendly%20expression%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20professional%20headshot&width=120&height=120&seq=avatar-reviewer-02&orientation=squarish',
    role: '资深漫友',
    rating: 5,
  },
  {
    id: 'review-3',
    text: '从学生时代就开始看韩漫，这个网站是我用过最好的。不仅有热门连载，还有很多经典老作品可以回味，真心好评！',
    author: '漫画老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20mature%20man%20with%20confident%20smile%2C%20simple%20dark%20background%2C%20clean%20illustration%20style%2C%20professional%20headshot&width=120&height=120&seq=avatar-reviewer-03&orientation=squarish',
    role: '十年漫龄',
    rating: 5,
  },
  {
    id: 'review-4',
    text: '韩漫大全真的是宝藏网站！翻译质量高，更新及时，而且界面设计也很舒服，看漫画的体验特别好。',
    author: '樱花落尽',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20young%20woman%20with%20long%20hair%2C%20gentle%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20professional%20headshot&width=120&height=120&seq=avatar-reviewer-04&orientation=squarish',
    role: '黄金会员',
    rating: 4,
  },
  {
    id: 'review-5',
    text: '种类真的很全，从恋爱到悬疑什么都有。最重要的是不用翻墙，直接就能看，太方便了。',
    author: '北方的狼',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20portrait%20avatar%2C%20cool%20young%20man%20with%20sharp%20features%2C%20simple%20cool%20tone%20background%2C%20clean%20illustration%20style%2C%20professional%20headshot&width=120&height=120&seq=avatar-reviewer-05&orientation=squarish',
    role: '活跃读者',
    rating: 5,
  },
];

export const featuredCollections = {
  hotSeries: {
    tagline: '追更不停，精彩不断',
    comicCount: '128部 连载中',
    tags: ['恋爱', '奇幻', '动作', '悬疑'],
  },
  newArrival: {
    tagline: '第一时间发现好作品',
    comicCount: '36部 新上架',
    badge: 'NEW',
  },
  completed: {
    tagline: '一口气读完的快乐',
    comicCount: '200+ 部完结',
  },
};